import { render, staticRenderFns } from "./ClassroomRoster.vue?vue&type=template&id=594d9d52"
import script from "./ClassroomRoster.vue?vue&type=script&lang=js"
export * from "./ClassroomRoster.vue?vue&type=script&lang=js"
import style0 from "./ClassroomRoster.vue?vue&type=style&index=0&id=594d9d52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports